var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OrderValidation } from './orderValidation';
import { CurrentOrderService } from './currentOrder.service';
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
var QuoteComponent = (function () {
    function QuoteComponent(titleService, translate, currentOrderService, _orderValidation) {
        var _this = this;
        this.titleService = titleService;
        this.translate = translate;
        this.currentOrderService = currentOrderService;
        this._orderValidation = _orderValidation;
        this.currentOrderService.orderMenuVisibility.subscribe(function (menu) { return _this.orderMenuVisibility = menu; });
        this.currentOrderService.order.subscribe(function (order) { return _this.order = order; });
        this.currentOrderService.orderType.subscribe(function (orderType) { return _this.orderType = orderType; });
        this.orderValidation = this._orderValidation;
        this.titleService.setTitle("Quote | Uptime");
        this.translate.get('ORDER.QUOTE_UPPERCASE').subscribe(function (value) {
            _this.currentOrderService.setOrderType({
                uppercaseType: "Quote",
                uppercaseLabel: value
            });
        });
        this.translate.get('ORDER.QUOTE_LOWERCASE').subscribe(function (value) {
            _this.currentOrderService.setOrderType({
                lowercaseType: "quote",
                lowercaseLabel: value
            });
        });
    }
    QuoteComponent = __decorate([
        Component({
            selector: 'cx-order',
            templateUrl: './order.component.html',
        }),
        __metadata("design:paramtypes", [Title,
            TranslateService,
            CurrentOrderService,
            OrderValidation])
    ], QuoteComponent);
    return QuoteComponent;
}());
export { QuoteComponent };
//# sourceMappingURL=quote.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/order/quote.component.js
// module id = 188
// module chunks = 0